module.exports = __webpack_public_path__ + "static/img/zhineng.ff6b19c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rocbox/zhineng.png
// module id = y/r7
// module chunks = 1